// =============================================================================
// Grimsthorpe Lake Admin - Theme / Color Palette
// Matches the client app visual language: dark theme, forest green, brass accents
// =============================================================================

export const COLORS = {
  // Primary brand colors
  primaryGreen: '#1B3B1B',
  primaryGreenLight: '#2D5A2D',
  primaryGreenMid: '#1F4F1F',
  forestGreen: '#2F4F2F',
  darkGreen: '#3F5F3F',

  // Gold / brass accent
  textGold: '#FFD700',
  goldMuted: '#E5D4A1',
  goldSubtle: '#8B7355',
  brass: '#B5864A',
  brassLight: '#C9A066',

  // Text colors
  textPrimary: '#FFFFFF',
  textSecondary: '#C0C0C0',
  textMuted: '#888888',
  textBody: '#E5D4A1',

  // Background colors
  backgroundPrimary: '#000000',
  backgroundSecondary: '#1A1A1A',
  backgroundTertiary: '#0A0A0A',
  backgroundCard: 'rgba(255, 255, 255, 0.03)',
  backgroundOverlay: 'rgba(0, 0, 0, 0.5)',
  backgroundSidebar: '#0D0D0D',

  // Borders
  borderDefault: '#333333',
  borderLight: '#444444',

  // Status colors
  statusSuccess: '#28A745',
  statusWarning: '#FFC107',
  statusError: '#DC3545',
  statusInfo: '#17A2B8',

  // Dues status
  duesPaid: '#28A745',
  duesPending: '#FFC107',
  duesOverdue: '#DC3545',
  duesGrace: '#17A2B8',

  // Condition colors
  conditionExcellent: '#28A745',
  conditionGood: '#5CB85C',
  conditionFair: '#FFC107',
  conditionPoor: '#FF8C00',
  conditionNeedsRepair: '#DC3545',
} as const;

export const SPACING = {
  xs: 4,
  sm: 8,
  md: 12,
  base: 16,
  lg: 20,
  xl: 24,
  xxl: 32,
  xxxl: 48,
} as const;

export const BORDER_RADIUS = {
  sm: 4,
  base: 8,
  md: 12,
  lg: 16,
} as const;
